import { css } from '@emotion/css'
import { breakpoint, mediaQueryHelper } from '@offerzen/pinata'

const styles = {
  wrapper: css({
    backgroundColor: '#E4F0FC',
    padding: '24px',
    margin: '8px 0 0',
  }),
  heading: css({
    color: '#132254',
    fontSize: '24px',
    fontWeight: '700',
    margin: '0 0 8px',
    lineHeight: '90%',
  }),
  content: css({
    fontSize: '16px',
    color: '#132254',
    fontWeight: '400',
    margin: '0 0 16px',
    lineHeight: '140%',
  }),
  ctas: css({
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',

    [mediaQueryHelper(breakpoint.phone)]: {
      flexDirection: 'row',
    },
  }),
  cta: css({
    backgroundColor: 'transparent',
    border: '1px solid #2f96f4',
    borderRadius: 4,
    maxHeight: 43,
    height: 43,
    color: '#2f96f4',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 10px',
    textDecoration: 'none',
    fontWeight: '600',
    transition: 'all .2s',

    '&:hover, &:focus': {
      backgroundColor: '#2f96f4',
      color: '#FFF',
    },

    [mediaQueryHelper(breakpoint.phone)]: {
      width: '50%',
    },
  }),
  ctaFilled: css({
    backgroundColor: '#2f96f4 !important',
    color: '#FFFFFF',
    '&:hover, &:focus': {
      boxShadow: '0px 4px 4px rgba(19, 34, 84, 0.15)',
    },
  }),
}

export default styles
